export interface WicketAdminEmailMessage {
  title: string;
  content: string; // HTML content to be used inside template if use_template, else full HTML message
  use_template: boolean;
}
